<template>
  <ul class="feed-tonal">
    <li class="feed-tonal__item feed-tonal__item--positive">
      {{$t('feed.feedTonal.positive')}}: <span class="feed-tonal-count">{{positive}}</span>
    </li>
    <li class="feed-tonal__item feed-tonal__item--neutral">
      {{$t('feed.feedTonal.neutral')}}: <span class="feed-tonal-count">{{neutral}}</span>
    </li>
    <li class="feed-tonal__item feed-tonal__item--negative">
      {{$t('feed.feedTonal.negative')}}: <span class="feed-tonal-count">{{negative}}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "FeedTonal",
  props: {
    additional: {
      type: Object,
      required: true
    },
    threadType: {
      type: String
    }
  },
  computed: {
    positive() {
      const positiveData = this.additional.publicationsgrowthwithtrust.positive;
      return this.accumulator(positiveData);
    },
    neutral() {
      const neutralData = this.additional.publicationsgrowthwithtrust.netural;
      return this.accumulator(neutralData);
    },
    negative() {
      const negativeData = this.additional.publicationsgrowthwithtrust.negative;
      return this.accumulator(negativeData);
    }
  },
  methods: {
    accumulator(data) {
      return data.reduce((sum, elem) => {
        return sum + elem[1];
      }, 0);
    }
  }
};
</script>

<style>
.feed-tonal {
  display: flex;
  padding: 0;
  margin: 0;
  font-family: "Roboto", "Arial", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  list-style: none;
}

.feed-tonal__item {
 position: relative;
  padding-right: 7px;
  margin-right: 5px;
}

.feed-tonal__item::after {
  position: absolute;
  right: 0;
  top: -1px;
  display: inline-block;
  color: #5E6D82;
  content: "|";
}

.feed-tonal__item--positive {
  color: #15CF49;
}

.feed-tonal__item--neutral {
  color: #5E6D82;
}

.feed-tonal__item--negative {
  color: #E42E2E;
}

.feed-tonal__item--not-tonal {
  color: #5E6D82;
}

.feed-tonal__item--negative::after,
.feed-tonal__item--not-tonal::after {
  display: none;
}

.feed-tonal-count {
  font-weight: 700;
}

.feed-tonal__item:last-child {
  padding-right: 0;
  margin-right: 0;
}
</style>
